<template>
    <div>

        <div v-for="(book, index) in books" :key="index" class="align-items-center bg-light card d-flex flex-md-row mb-3">
            <RouterLink :to="bookLink(book)" class="card-img-book-dashboard flex-shrink-0 rounded" :style="{'background-image': `url(${book.thumbnail})`}"></RouterLink>
            <div class="align-items-md-center d-md-flex flex-md-grow-1 justify-content-md-between p-3">
                <RouterLink :to="bookLink(book)" class="text-dark text-decoration-none">
                    <h5>{{book.title}}</h5>
                    <p class="small">{{book.createdAt | moment("from") }}</p>
                    <div class="mt-n3 mb-1">
                        <div class="badge badge-pill badge-info mr-1" v-for="category in book.categories" :key="category">{{category}}</div>
                        <div class="badge badge-pill badge-warning mr-1" v-for="tag in book.tags" :key="tag" v-show="tag != 'none'">{{tag}}</div>
                    </div>
                </RouterLink>
                <div class="text-center text-md-right flex-shrink-0">
                    <RouterLink :to="{name: 'EditBook', params: {id: book.bookId}}" class="btn btn-warning mr-3 mt-2">Editar
                        <i class="fa-pen fas"></i>
                    </RouterLink>
                    <button type="button" @click="doDelete(book.bookId)" class="btn btn-danger mt-2">Eliminar
                        <i class="fa-trash fas"></i>
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    created(){
        this.$store.dispatch('book/getBooks', Infinity)
    },
    methods:{
        doDelete(id){
            if(window.confirm('¿Realmente quiere eliminar el libro?')){
                this.$store.dispatch('book/doDelete', id)
            }
        },
        bookLink(book){
            return {name:'Book', params:{id: book.bookId}}
        },
    },
    computed:{
        books(){
            return this.$store.state.book.books
        }
    }
}
</script>
